function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zm-.003-4.8a3.2 3.2 0 01-3.2-3.2h-2.4a5.6 5.6 0 1011.2 0h-2.4a3.2 3.2 0 01-3.2 3.2z",
  fill: "#A7AEB7"
});

var SvgJoyToken = function SvgJoyToken(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDE2QzEyLjQxODMgMTYgMTYgMTIuNDE4MyAxNiA4QzE2IDMuNTgxNzIgMTIuNDE4MyAwIDggMEMzLjU4MTcyIDAgMCAzLjU4MTcyIDAgOEMwIDEyLjQxODMgMy41ODE3MiAxNiA4IDE2Wk03Ljk5Njg4IDExLjJDNi4yMjk1NiAxMS4yIDQuNzk2ODggOS43NjczMSA0Ljc5Njg4IDhIMi4zOTY4OEMyLjM5Njg4IDExLjA5MjggNC45MDQwOCAxMy42IDcuOTk2ODggMTMuNkMxMS4wODk3IDEzLjYgMTMuNTk2OSAxMS4wOTI4IDEzLjU5NjkgOEgxMS4xOTY5QzExLjE5NjkgOS43NjczMSA5Ljc2NDE5IDExLjIgNy45OTY4OCAxMS4yWiIgZmlsbD0iI0E3QUVCNyIvPgo8L3N2Zz4K";
export { SvgJoyToken as ReactComponent };